const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentMessageRow.tsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';

type AppointmentMessageRowProps = {
    text: string;
};

export const AppointmentMessageRow = (props: AppointmentMessageRowProps) => {
    const { text } = props;

    return (
        <Grid size={{ xs: 12 }}>
            <Typography sx={{ color: 'primary.main' }}>{text}</Typography>
        </Grid>
    );
};
